(function() {
  'use strict';

  // --- CONFIGURATION FOR SHOPIFY STOREFRONT API ---
  // Replace with your Storefront API details.
  // IMPORTANT: This token is public. Ensure it only has permissions for product reading.
  const storefront = {
    accessToken: window.bestelSnelConfig?.storefrontAccessToken,
    // Usa o domínio configurado ou fallback para o hardcoded
    apiUrl: `https://${window.bestelSnelConfig?.shopUrl}/api/2026-01/graphql.json`
  };

  const useMockRetrieveResponse = false;

  // --- PAGINATION STATE ---
  let currentPage = 1;
  const productsPerPage = 64; // Display 20 products per page
  let fullProductGidList = []; // Holds the full list of product GIDs for the session
  let originalProductGidListBeforeReorder = []; // Backup for cancellation
  
  /* --- INÍCIO DO CÓDIGO DE FILTROS (VARIÁVEIS) --- */
  let allProductDetails = []; // Guarda vendor, tags e id de todos os produtos
  let activeFilterGidList = []; // Lista atual mostrada (pode estar filtrada)
  let isFilterActive = false;
  const MAIN_CATEGORIES = ["IJs", "Chocolade", "Patisserie", "Mallen & vormen"];
  /* --- FIM DO CÓDIGO DE FILTROS (VARIÁVEIS) --- */
  
  // --- QUANTITY STATE MANAGEMENT ---
  function getStoredQuantities() {
    return JSON.parse(localStorage.getItem('quickOrderQuantities') || '{}');
  }
  
  function updateStoredQuantity(variantId, quantity) {
    const quantities = getStoredQuantities();
    if (quantity > 0) {
      quantities[variantId] = quantity;
    } else {
      delete quantities[variantId];
    }
  
    localStorage.setItem('quickOrderQuantities', JSON.stringify(quantities));
  }
  
  /**
   * Fetches the paginated list of products. 
   * This now fetches only the products for the current page from the Storefront API.
   *
   * @returns {Promise<{products: Array, total_count: number}>} An object containing the products for the current page and the total number of products.
   */
  async function getPaginatedProducts() {
    /* --- INÍCIO DO CÓDIGO DE FILTROS (PAGINAÇÃO) --- */
    const listToPaginate = isFilterActive ? activeFilterGidList : fullProductGidList;
    const total_count = listToPaginate.length;
    
    // 1. Calculate the slice of GIDs for the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    const paginatedGids = listToPaginate.slice(startIndex, endIndex);
    /* --- FIM DO CÓDIGO DE FILTROS (PAGINAÇÃO) --- */
  
    if (paginatedGids.length === 0) {
      return { products: [], total_count };
    }
  
    // 2. Fetch product details for the current page's GIDs
    const storefrontQuery = `
      query getProductsByIds($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            handle
            vendor
            featuredImage { url }
            variants(first: 1) {
              nodes {
                id
                sku
              }
            }
          }
        }
      }
    `;
    const storefrontData = await fetchFromStorefrontAPI(storefrontQuery, { ids: paginatedGids });
    const productNodes = storefrontData.nodes || [];
  
    // 3. Map the results and re-order them to match the paginated GID list
    const fetchedProductsMap = new Map(productNodes.filter(Boolean).map(node => [node.id, node]));
  
    const orderedProducts = paginatedGids.map(gid => {
      const node = fetchedProductsMap.get(gid);
      if (!node) return null;
  
      const firstVariant = node.variants?.nodes?.[0];
      return {
        id: Number(node.id.split('/').pop()),
        title: node.title,
        handle: node.handle,
        vendor: node.vendor,
        imageUrl: node.featuredImage?.url || '',
        variantId: firstVariant ? Number(firstVariant.id.split('/').pop()) : null,
        sku: firstVariant?.sku || '-'
      };
    }).filter(Boolean);
  
    console.log(`[Page ${currentPage}] Products processed:`, orderedProducts);
  
    return {
      products: orderedProducts,
      total_count: total_count
    };
  }  
  /**
   * Renders the pagination controls (prev/next buttons, page info).
   * @param {number} totalProducts - The total number of products across all pages.
   */
  function renderPaginationControls(totalProducts) {
    const totalPages = Math.ceil(totalProducts / productsPerPage);
    const container = document.getElementById('pagination-container');

    if (!container) return;
    
    if (totalPages <= 1) {
        container.innerHTML = '';
        return;
    }

    container.innerHTML = `
      <button id="prev-page-btn" class="button button--secondary" ${currentPage === 1 ? 'disabled' : ''}>Vorige</button>
      <span class="pagination-info">Pagina ${currentPage} van ${totalPages}</span>
      <button id="next-page-btn" class="button button--secondary" ${currentPage === totalPages ? 'disabled' : ''}>Volgende</button>
    `;

    document.getElementById('prev-page-btn')?.addEventListener('click', () => {
      if (currentPage > 1) {
        currentPage--;
        renderPage();
      }
    });

    document.getElementById('next-page-btn')?.addEventListener('click', () => {
      if (currentPage < totalPages) {
        currentPage++;
        renderPage();
      }
    });
  }

  /**
   * Creates a table row element for a given product.
   * @param {object} product - The product data.
   * @returns {HTMLTableRowElement} The created <tr> element.
   */
  function createProductRow(product) {
    const productId = product.id;
    const variantId = product.variantId || product.variants?.[0]?.id || productId;
    const sku = product.sku || '-';
    const imageUrl = product.imageUrl || '';
    const storedQty = getStoredQuantities()[variantId] || 0;

    const newRow = document.createElement('tr');
    newRow.dataset.productId = productId;
    newRow.innerHTML = `
        <td data-label="Afbeelding">
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title.replace(/"/g, '&quot;')}" style="max-width: 80px; height: auto;">` : '<div style="width: 80px; height: 80px; background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 12px;">Geen foto</div>'}
        </td>
        <td data-label="Product"><strong><a href="/products/${product.handle}" target="_blank">${product.title}</a></strong></td>
        <td data-label="SKU">${sku}</td>
        <td data-label="Merk">${product.vendor || '-'}</td>
        <td data-label="Aantal">
            <div class="quantity-selector">
                <button type="button" class="quantity-btn minus-btn" data-variant-id="${variantId}">−</button>
                <span class="quantity-value" data-variant-id="${variantId}">${storedQty}</span>
                <button type="button" class="quantity-btn plus-btn" data-variant-id="${variantId}">+</button>
            </div>
        </td>
        <td data-label="Acties">
            <div class="button-actions-wrapper">
                <button type="button" class="add-to-cart-btn" data-variant-id="${variantId}">Toevoegen</button>
                <button type="button" class="remove-from-list-btn" data-product-id="${productId}" title="Verwijder van lijst">&times;</button>
            </div>
            <div class="reorder-controls">
                <button type="button" class="reorder-up-btn">▲</button>
                <button type="button" class="reorder-down-btn">▼</button>
            </div>
        </td>
    `;
    return newRow;
  }

  /**
   * Renders a specific page of products in the table.
   */
  async function renderPage() {
    const tableBody = document.querySelector('.quick-order-table tbody');
    if (!tableBody) return;

    // Show loader
    const numberOfColumns = document.querySelector('.quick-order-table thead th')?.length || 6;
    tableBody.innerHTML = `
        <tr>
          <td colspan="${numberOfColumns}">
            <div class="inline-loader-container">
                <div class="loader"></div>
                <span>Producten laden...</span>
            </div>
          </td>
        </tr>
      `;

    // Fetch the data for the current page
    const { products: pageProducts, total_count } = await getPaginatedProducts();

    // Clear current table content (which is the loader)
    tableBody.innerHTML = '';

    // Add new rows
    pageProducts.forEach(product => {
      const row = createProductRow(product);
      attachEventListenersToRow(row);
      tableBody.appendChild(row);
    });
    
    // Adjust current page if it's out of bounds (e.g., after deleting the last item on a page)
    const totalPages = Math.ceil(total_count / productsPerPage);
    if (currentPage > totalPages && totalPages > 0) {
        currentPage = totalPages;
        renderPage(); // Re-render with the corrected page number
        return;
    }

    // Update the pagination controls
    renderPaginationControls(total_count);
  }
  
  function updateCart() {
    console.log('Refreshing cart using global theme function...');
    
    // Dispara eventos para que o tema e apps de terceiros (Massy, etc) atualizem os preços
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    } else {
      console.error('window.refreshCart() is not available. Performing fallback count update.');
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          document.querySelectorAll('[data-cart-count], [data-header-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
        });
    }
  }

  function attachEventListenersToRow(row) {
    row.querySelector('.minus-btn')?.addEventListener('click', function() {
        const valueSpan = row.querySelector('.quantity-value');
        let currentValue = parseInt(valueSpan.textContent);
        if (currentValue > 0) currentValue--;
        valueSpan.textContent = currentValue;
        updateStoredQuantity(this.dataset.variantId, currentValue);
    });

    row.querySelector('.plus-btn')?.addEventListener('click', function() {
        const valueSpan = row.querySelector('.quantity-value');
        let currentValue = parseInt(valueSpan.textContent);
        currentValue++;
        valueSpan.textContent = currentValue;
        updateStoredQuantity(this.dataset.variantId, currentValue);
    });

    row.querySelector('.add-to-cart-btn')?.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        const valueSpan = row.querySelector('.quantity-value');
        const quantity = parseInt(valueSpan.textContent);
        const btn = this;

        if (quantity < 1) return alert('Voer een geldig aantal in');
        
        btn.disabled = true;
        const originalText = btn.textContent;
        btn.textContent = 'Bezig...';

        // Usar FormData para imitar o comportamento da Product Page (essencial para apps de desconto)
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        formData.append('sections', 'helper-cart,header');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
        })
        .then(response => response.json())
        .then((data) => {
            console.log('[Bestel Snel] add.js Response:', data);
            // Delay de 300ms essencial para o servidor do Shopify registar o desconto na sessão
            setTimeout(() => {
                updateCart(data.sections);
            }, 300);

            btn.textContent = 'Toegevoegd!';
            setTimeout(() => {
                btn.disabled = false;
                btn.textContent = originalText;
                valueSpan.textContent = '0';
                updateStoredQuantity(variantId, 0);
            }, 2000);
        })
        .catch(error => {
            console.error('Error:', error);
            btn.disabled = false;
            btn.textContent = originalText;
        });
    });

    row.querySelector('.remove-from-list-btn')?.addEventListener('click', async function() {
        const productId = this.dataset.productId;
        if (!confirm('Weet je zeker dat je dit product wilt verwijderen?')) return;

        this.disabled = true;
        const originalContent = this.innerHTML;
        this.innerHTML = '...';
        
        const productGid = `gid://shopify/Product/${productId}`;
        const success = await removeProductsFromQuickOrder([productGid]);

        if (success) {
            // Clear the stored quantity for the removed product from local storage.
            const variantId = row.querySelector('[data-variant-id]')?.dataset.variantId;
            if (variantId) {
                updateStoredQuantity(variantId, 0);
            }

            const productGidToRemove = `gid://shopify/Product/${productId}`;
            fullProductGidList = fullProductGidList.filter(gid => gid !== productGidToRemove);
            
            // Atualizar os filtros para remover tags ou vendors caso sejam os últimos do tipo
            populateFilterDropdowns();

            // Update header count (if not active filtering, handled by applyQuickFilters otherwise)
            if (typeof isFilterActive === 'undefined' || !isFilterActive) {
                const listHeader = document.querySelector('.list-header p');
                if (listHeader) listHeader.textContent = `Je hebt ${fullProductGidList.length} producten in je lijst`;
            }

            if (fullProductGidList.length === 0) {
                const listWrapper = document.getElementById('quick-order-list-wrapper');
                const emptyMessage = document.getElementById('empty-list-message');
                if (listWrapper) listWrapper.style.display = 'none';
                if (emptyMessage) emptyMessage.style.display = 'block';
            } else {
                // Reaplicar filtros depois de remover
                if (typeof isFilterActive !== 'undefined' && isFilterActive && document.getElementById('quick-order-filters')) {
                    applyQuickFilters();
                } else {
                    renderPage();
                }
            }

        } else {
            this.disabled = false;
            this.innerHTML = originalContent;
            alert('Er is iets misgegaan bij het verwijderen van het product. Probeer het opnieuw.');
        }
    });

    row.querySelector('.reorder-up-btn')?.addEventListener('click', function() {
        const currentRow = this.closest('tr');
        const previousRow = currentRow.previousElementSibling;
        const currentGid = `gid://shopify/Product/${currentRow.dataset.productId}`;
        
        const activeList = isFilterActive ? activeFilterGidList : fullProductGidList;
        const currentActiveIndex = activeList.indexOf(currentGid);

        let targetGid = null;

        if (previousRow) {
            targetGid = `gid://shopify/Product/${previousRow.dataset.productId}`;
            currentRow.parentNode.insertBefore(currentRow, previousRow);
        } else if (currentPage > 1 && currentActiveIndex > 0) {
            targetGid = activeList[currentActiveIndex - 1];
        }

        if (targetGid) {
            // Swap in active list (if filtered)
            if (isFilterActive) {
                const targetActiveIndex = activeList.indexOf(targetGid);
                if (currentActiveIndex !== -1 && targetActiveIndex !== -1) {
                    [activeList[currentActiveIndex], activeList[targetActiveIndex]] = [activeList[targetActiveIndex], activeList[currentActiveIndex]];
                }
            }

            // Swap in full list
            const currentIndexFull = fullProductGidList.indexOf(currentGid);
            const targetIndexFull = fullProductGidList.indexOf(targetGid);
            if (currentIndexFull !== -1 && targetIndexFull !== -1) {
                [fullProductGidList[currentIndexFull], fullProductGidList[targetIndexFull]] = [fullProductGidList[targetIndexFull], fullProductGidList[currentIndexFull]];
            }

            if (!previousRow) {
                renderPage(); // Cross-page swap requires re-render
            }
        }
    });

    row.querySelector('.reorder-down-btn')?.addEventListener('click', function() {
        const currentRow = this.closest('tr');
        const nextRow = currentRow.nextElementSibling;
        const currentGid = `gid://shopify/Product/${currentRow.dataset.productId}`;
        
        const activeList = isFilterActive ? activeFilterGidList : fullProductGidList;
        const currentActiveIndex = activeList.indexOf(currentGid);
        const totalPages = Math.ceil(activeList.length / productsPerPage);

        let targetGid = null;

        if (nextRow) {
            targetGid = `gid://shopify/Product/${nextRow.dataset.productId}`;
            currentRow.parentNode.insertBefore(nextRow, currentRow);
        } else if (currentPage < totalPages && currentActiveIndex < activeList.length - 1) {
            targetGid = activeList[currentActiveIndex + 1];
        }

        if (targetGid) {
            // Swap in active list (if filtered)
            if (isFilterActive) {
                const targetActiveIndex = activeList.indexOf(targetGid);
                if (currentActiveIndex !== -1 && targetActiveIndex !== -1) {
                    [activeList[currentActiveIndex], activeList[targetActiveIndex]] = [activeList[targetActiveIndex], activeList[currentActiveIndex]];
                }
            }

            // Swap in full list
            const currentIndexFull = fullProductGidList.indexOf(currentGid);
            const targetIndexFull = fullProductGidList.indexOf(targetGid);
            if (currentIndexFull !== -1 && targetIndexFull !== -1) {
                [fullProductGidList[currentIndexFull], fullProductGidList[targetIndexFull]] = [fullProductGidList[targetIndexFull], fullProductGidList[currentIndexFull]];
            }

            if (!nextRow) {
                renderPage(); // Cross-page swap requires re-render
            }
        }
    });
  }
  
  async function fetchFromStorefrontAPI(query, variables = {}) {
    if (storefront.accessToken === 'YOUR_STOREFRONT_API_ACCESS_TOKEN' || storefront.apiUrl.includes('YOUR_SHOP_NAME')) {
        const errorMsg = 'Storefront API credentials are not configured in bestel-snel.js';
        console.error(errorMsg);
        // Do not alert in production, but this is useful for development
        // alert(errorMsg); 
        throw new Error(errorMsg);
    }
    
    const response = await fetch(storefront.apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefront.accessToken
        },
        body: JSON.stringify({ query, variables }),
        cache: 'no-store'
    });
    
    if (!response.ok) {
        const errorBody = await response.text();
        console.error('GraphQL request failed:', errorBody);
        throw new Error(`GraphQL request failed with status ${response.status}`);
    }

    const json = await response.json();
    if (json.errors) {
        console.error('GraphQL Errors:', json.errors);
        throw new Error('GraphQL query returned errors.');
    }
    
    return json.data;
  }

/* --- INÍCIO DO CÓDIGO DE FILTROS (LÓGICA CORE) --- */
async function fetchAllProductDataForFilters() {
    // Se a grelha de filtros não existir no DOM (utilizador sem permissão), abortamos.
    const filtersContainer = document.getElementById('quick-order-filters');
    if (!filtersContainer) return;
    
    // Mostrar imediatamente os filtros para garantir que aparecem sempre
    filtersContainer.style.display = 'flex';
    
    if (fullProductGidList.length === 0) {
        // Se a lista estiver vazia, apenas limpamos/inicializamos as dropdowns sem popular os dados
        populateFilterDropdowns();
        return;
    }
    
    // Obter dados do Storefront em blocos para todos os GIDs (apenas vendor e tags)
    const CHUNK_SIZE = 250;
    allProductDetails = [];
    
    for (let i = 0; i < fullProductGidList.length; i += CHUNK_SIZE) {
        const chunk = fullProductGidList.slice(i, i + CHUNK_SIZE);
        const query = `
          query getFilterData($ids: [ID!]!) {
            nodes(ids: $ids) {
              ... on Product { id, vendor, tags }
            }
          }
        `;
        const data = await fetchFromStorefrontAPI(query, { ids: chunk });
        if (data && data.nodes) {
            allProductDetails = allProductDetails.concat(data.nodes.filter(Boolean));
        }
    }
    
    populateFilterDropdowns();
}

function populateFilterDropdowns() {
    // Se a grelha de filtros não existir no DOM (utilizador sem permissão), abortamos silenciosamente
    if (!document.getElementById('quick-order-filters')) return;

    const categorySet = new Set();
    const categorySelect = document.getElementById('filter-category');
    const currentCategory = categorySelect ? categorySelect.value : '';
    
    // Apenas os produtos que estão presentemente na lista
    const activeProducts = allProductDetails.filter(prod => fullProductGidList.includes(prod.id));

    activeProducts.forEach(prod => {
        if (prod.tags) {
            prod.tags.forEach(tag => {
                const matchedCategory = MAIN_CATEGORIES.find(mainCat => mainCat.toLowerCase() === tag.toLowerCase());
                if (matchedCategory) {
                    categorySet.add(matchedCategory);
                }
            });
        }
    });

    if (categorySelect) {
        categorySelect.innerHTML = '<option value="">Alle categorieën</option>';
        MAIN_CATEGORIES.forEach(cat => {
            if (categorySet.has(cat)) {
                const option = document.createElement('option');
                option.value = cat;
                option.textContent = cat;
                categorySelect.appendChild(option);
            }
        });
        
        if (categorySet.has(currentCategory)) {
            categorySelect.value = currentCategory;
        }
    }

    updateSubcategoryDropdown();
    updateBrandDropdown();
}

function updateSubcategoryDropdown() {
    const categorySelect = document.getElementById('filter-category');
    if (!categorySelect) return; // Abortar se os filtros não existirem no DOM
    
    const category = categorySelect.value;
    const brandSelect = document.getElementById('filter-brand');
    const brand = brandSelect ? brandSelect.value : '';
    const subCategorySelect = document.getElementById('filter-subcategory');
    
    // Guardar a escolha atual para tentar restaurar se for viável
    const currentSubcategory = subCategorySelect.value;
    
    // Limpar as opções atuais
    subCategorySelect.innerHTML = '<option value="">Alle subcategorieën</option>';
    
    subCategorySelect.disabled = false;
    const subCategorySet = new Set();
    
    // Apenas os produtos que estão presentemente na lista
    const activeProducts = allProductDetails.filter(prod => fullProductGidList.includes(prod.id));

    // Procura por todas as tags válidas nos produtos (se houver categoria, filtra por ela primeiro)
    activeProducts.forEach(prod => {
        const matchesCategory = !category || (prod.tags && prod.tags.includes(category));
        const matchesBrand = !brand || prod.vendor === brand;
        
        if (matchesCategory && matchesBrand && prod.tags) {
            prod.tags.forEach(tag => {
                const isMainCategory = MAIN_CATEGORIES.some(mainCat => mainCat.toLowerCase() === tag.toLowerCase());
                if (!isMainCategory) {
                    subCategorySet.add(tag);
                }
            });
        }
    });

    Array.from(subCategorySet).sort().forEach(sub => {
        const option = document.createElement('option');
        option.value = sub;
        option.textContent = sub;
        subCategorySelect.appendChild(option);
    });
    
    // Repor a opção caso ela continue ligada à categoria/brand escolhida
    if (subCategorySet.has(currentSubcategory)) {
        subCategorySelect.value = currentSubcategory;
    }
}

function updateBrandDropdown() {
    const brandSelect = document.getElementById('filter-brand');
    if (!brandSelect) return;

    const categorySelect = document.getElementById('filter-category');
    const subCategorySelect = document.getElementById('filter-subcategory');
    
    const category = categorySelect ? categorySelect.value : '';
    const subcategory = subCategorySelect ? subCategorySelect.value : '';
    const currentBrand = brandSelect.value;
    
    brandSelect.innerHTML = '<option value="">Alle merken</option>';
    const brandSet = new Set();

    const activeProducts = allProductDetails.filter(prod => fullProductGidList.includes(prod.id));

    activeProducts.forEach(prod => {
        const matchesCategory = !category || (prod.tags && prod.tags.includes(category));
        const matchesSubcategory = !subcategory || (prod.tags && prod.tags.includes(subcategory));
        
        if (matchesCategory && matchesSubcategory && prod.vendor) {
            brandSet.add(prod.vendor);
        }
    });

    Array.from(brandSet).sort().forEach(brand => {
        const option = document.createElement('option');
        option.value = brand;
        option.textContent = brand;
        brandSelect.appendChild(option);
    });
    
    if (brandSet.has(currentBrand)) {
        brandSelect.value = currentBrand;
    }
}

function applyQuickFilters() {
    const categorySelect = document.getElementById('filter-category');
    if (!categorySelect) return; // Abortar se os filtros não existirem no DOM

    const category = categorySelect.value;
    const subcategory = document.getElementById('filter-subcategory').value;
    const brand = document.getElementById('filter-brand').value;

    if (!category && !subcategory && !brand) {
        isFilterActive = false;
        activeFilterGidList = [];
    } else {
        isFilterActive = true;
        
        const activeProducts = allProductDetails.filter(prod => fullProductGidList.includes(prod.id));

        const filteredNodes = activeProducts.filter(prod => {
            let matchesCategory = true;
            let matchesSub = true;
            let matchesBrand = true;
            
            if (category) matchesCategory = prod.tags && prod.tags.includes(category);
            if (subcategory) matchesSub = prod.tags && prod.tags.includes(subcategory);
            if (brand) matchesBrand = prod.vendor === brand;
            
            return matchesCategory && matchesSub && matchesBrand;
        });
        
        activeFilterGidList = filteredNodes.map(n => n.id);
        
        // Mantém a ordenação global base exigida pelo Quick-Manager
        activeFilterGidList.sort((a, b) => {
            return fullProductGidList.indexOf(a) - fullProductGidList.indexOf(b);
        });
    }

    // Update header count to match filtered view or total
    const listHeader = document.querySelector('.list-header p');
    if (listHeader) {
        const count = isFilterActive ? activeFilterGidList.length : fullProductGidList.length;
        listHeader.textContent = `Je hebt ${count} producten in je lijst`;
    }

    currentPage = 1;
    renderPage();
}

function clearFilters() {
    document.getElementById('filter-category').value = '';
    document.getElementById('filter-subcategory').value = '';
    document.getElementById('filter-brand').value = '';
    updateSubcategoryDropdown();
    updateBrandDropdown();
    applyQuickFilters();
}
/* --- FIM DO CÓDIGO DE FILTROS (LÓGICA CORE) --- */

  document.addEventListener('DOMContentLoaded', function() {
    console.log('Bestel snel script loaded');
    
    /* --- INÍCIO DO CÓDIGO DE FILTROS (INIT) --- */
    document.getElementById('filter-category')?.addEventListener('change', () => {
        // Se a marca não tiver nada a ver com a categoria, a dropdown da subcategoria esvazia se ler o valor da marca
        // Assim limpamos os valores filhos se eles não fizerem sentido com o elemento pai selecionado
        const brandSelect = document.getElementById('filter-brand');
        const subCategorySelect = document.getElementById('filter-subcategory');
        
        let shouldResetBrand = false;
        if (brandSelect && brandSelect.value !== '') {
            // Verifica se a marca atual existe nesta categoria
            const categoryValue = document.getElementById('filter-category').value;
            const hasBrandInCategory = allProductDetails.some(prod => 
                fullProductGidList.includes(prod.id) && 
                prod.vendor === brandSelect.value && 
                (!categoryValue || (prod.tags && prod.tags.includes(categoryValue)))
            );
            if (!hasBrandInCategory) {
                shouldResetBrand = true;
                brandSelect.value = '';
            }
        }
        
        if (subCategorySelect && subCategorySelect.value !== '') {
             const categoryValue = document.getElementById('filter-category').value;
             const hasSubInCategory = allProductDetails.some(prod => 
                fullProductGidList.includes(prod.id) && 
                prod.tags && prod.tags.includes(subCategorySelect.value) && 
                (!categoryValue || prod.tags.includes(categoryValue))
            );
            if (!hasSubInCategory) {
                subCategorySelect.value = '';
            }
        }

        updateBrandDropdown();
        updateSubcategoryDropdown();
        applyQuickFilters();
    });
    document.getElementById('filter-subcategory')?.addEventListener('change', () => {
        const brandSelect = document.getElementById('filter-brand');
        if (brandSelect && brandSelect.value !== '') {
            const subValue = document.getElementById('filter-subcategory').value;
            const categoryValue = document.getElementById('filter-category').value;
            
            const hasBrandInSub = allProductDetails.some(prod => 
                fullProductGidList.includes(prod.id) && 
                prod.vendor === brandSelect.value && 
                (!subValue || (prod.tags && prod.tags.includes(subValue))) &&
                (!categoryValue || (prod.tags && prod.tags.includes(categoryValue)))
            );
            if (!hasBrandInSub) {
                brandSelect.value = '';
            }
        }
        
        updateBrandDropdown();
        applyQuickFilters();
    });
    
    document.getElementById('filter-brand')?.addEventListener('change', () => {
        const subCategorySelect = document.getElementById('filter-subcategory');
        if (subCategorySelect && subCategorySelect.value !== '') {
            const brandValue = document.getElementById('filter-brand').value;
            const categoryValue = document.getElementById('filter-category').value;
            
            const hasSubInBrand = allProductDetails.some(prod => 
                fullProductGidList.includes(prod.id) && 
                (!brandValue || prod.vendor === brandValue) && 
                (prod.tags && prod.tags.includes(subCategorySelect.value)) &&
                (!categoryValue || (prod.tags && prod.tags.includes(categoryValue)))
            );
            if (!hasSubInBrand) {
                subCategorySelect.value = '';
            }
        }
        
        updateSubcategoryDropdown();
        applyQuickFilters();
    });
    document.getElementById('clear-filters-btn')?.addEventListener('click', clearFilters);
    /* --- FIM DO CÓDIGO DE FILTROS (INIT) --- */
    
    // Fetch full list from server to ensure we have all products (Liquid limit is 50)
    fetchFullProductList().then(() => {
        fetchAllProductDataForFilters();
    });

    const addAllToCartHandler = function(event) {
        event.preventDefault();
        const btn = this;
        const originalText = btn.textContent;
        
        const storedQuantities = getStoredQuantities();
        const items = Object.entries(storedQuantities).map(([variantId, qty]) => ({
          id: variantId,
          quantity: qty
        })).filter(item => item.quantity > 0);

        if (items.length === 0) {
          alert('Selecteer een aantal groter dan 0 voor ten minste één product in je lijst.');
          btn.disabled = false;
          btn.textContent = originalText;
          return;
        }
        
        btn.disabled = true;
        btn.textContent = 'Bezig...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ 
            items: items,
            // Garante que o add-all também força o recálculo de descontos
            sections: 'helper-cart,header'
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(errorData => { throw new Error(errorData.description || 'Unknown error'); });
          }
          return response.json();
        })
        .then((data) => {
          console.log('[Bestel Snel] add-all Response:', data);
          btn.textContent = 'Alles toegevoegd!';
          setTimeout(() => {
            updateCart(data.sections);
          }, 300);
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
            // Clear stored quantities and update UI
            localStorage.removeItem('quickOrderQuantities');
            document.querySelectorAll('.quantity-value').forEach(el => el.textContent = '0');
          }, 2500);
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Er ging iets mis: ' + error.message);
          btn.disabled = false;
          btn.textContent = originalText;
        });
      };

    const addAllButton = document.getElementById('add-all-to-cart-btn');
    if (addAllButton) {
      addAllButton.addEventListener('click', addAllToCartHandler);
    }

    // --- REORDER FUNCTIONALITY ---
    const reorderBtn = document.getElementById('reorder-btn');
    const saveOrderBtn = document.getElementById('save-order-btn');
    const cancelReorderBtn = document.getElementById('cancel-reorder-btn');

    function setReorderMode(enabled) {
        const actionsContainer = document.querySelector('.list-header__actions');
        const quickOrderTable = document.querySelector('.quick-order-table');
        if (actionsContainer) {
            actionsContainer.classList.toggle('reorder-active', enabled);
        }
        if (quickOrderTable) {
            quickOrderTable.classList.toggle('reorder-active', enabled);
        }
    }

    if (reorderBtn) {
      reorderBtn.addEventListener('click', function() {
        // Backup the current order
        originalProductGidListBeforeReorder = [...fullProductGidList];
        setReorderMode(true);
      });
    }

    if (saveOrderBtn) {
      saveOrderBtn.addEventListener('click', async function() {
        const btn = this;
        btn.disabled = true;
        const originalText = btn.textContent;
        btn.textContent = 'Opslaan...';

        try {
            const response = await fetch('/apps/quick-manager', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    intent: 'update',
                    productGids: fullProductGidList // Send the already up-to-date list
                })
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                const errorMessage = getErrorMessageFromResult(result);
                throw new Error(errorMessage);
            }
            
            // Clear the backup list as the new order is now saved
            originalProductGidListBeforeReorder = [];

        } catch (error) {
            console.error('Error saving new order:', error);
            alert('De nieuwe volgorde kon niet worden opgeslagen. Probeer het opnieuw.');
            // If save fails, revert to the original order
            fullProductGidList = [...originalProductGidListBeforeReorder];
        } finally {
            // Exit reorder mode and re-render to show the correct list (either new or reverted)
            setReorderMode(false);
            await renderPage();
            btn.disabled = false;
            btn.textContent = originalText;
        }
      });
    }

    if(cancelReorderBtn) {
        cancelReorderBtn.addEventListener('click', async function() {
            // Restore the list from the backup
            if (originalProductGidListBeforeReorder.length > 0) {
                fullProductGidList = [...originalProductGidListBeforeReorder];
            }
            
            // Exit reorder mode
            setReorderMode(false);

            // Re-render the page to show the original order
            await renderPage();
        });
    }
    
    // ===== SEARCH FIELD FUNCTIONALITY =====
    var searchInput = document.getElementById('quick-order-search');
    var resultsContainer = document.getElementById('quick-order-search-results');
    
    if (searchInput && resultsContainer) {
      var searchTimeout;
      const searchCache = {}; // Cache for search results
      
      searchInput.addEventListener('input', function(e) {
        var query = e.target.value.trim();
        clearTimeout(searchTimeout);
        if (query.length < 2) {
          resultsContainer.classList.remove('active');
          resultsContainer.innerHTML = '';
          return;
        }
        // Increased debounce time to 500ms
        searchTimeout = setTimeout(() => searchProducts(query), 700); 
      });
      
      document.addEventListener('click', function(e) {
        if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
          resultsContainer.classList.remove('active');
        }
      });
      
      async function searchProducts(query) {
        // 1. Check cache first
        if (searchCache[query]) {
          console.log(`[Bestel Snel] Serving search results from cache for: ${query}`);
          displaySearchResults(searchCache[query]);
          resultsContainer.classList.add('active');
          return;
        }

        try {
          resultsContainer.innerHTML = '<div class="search-no-results">Zoeken...</div>';
          resultsContainer.classList.add('active');

          console.log(`[Bestel Snel] Searching via App Proxy for: ${query}`);

          const response = await fetch('/apps/quick-manager', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ intent: 'search_products', query: query })
          });

          const result = await response.json();

          if (result.success && Array.isArray(result.products)) {
            console.log('App Proxy search results:', result.products);
            // 2. Store successful results in cache
            searchCache[query] = result.products;
            displaySearchResults(result.products);
          } else {
            throw new Error(getErrorMessageFromResult(result) || 'Search via proxy failed');
          }

        } catch (error) {
          console.error('Search error:', error);
          resultsContainer.innerHTML = `<div class="search-no-results">Fout bij het zoeken: ${error.message}</div>`;
          resultsContainer.classList.add('active');
        }
      }
      
      function displaySearchResults(products) {
        if (products.length === 0) {
          resultsContainer.innerHTML = '<div class="search-no-results">Geen producten gevonden</div>';
          return;
        }
        
        resultsContainer.innerHTML = products.map(product => {
          const productDataString = JSON.stringify(product).replace(/"/g, '&quot;');
          return `<div class="search-result-item">
            <img src="${product.image || ''}" alt="${product.title}">
            <div class="search-result-info">
              <h4><a href="/products/${product.handle}" target="_blank">${product.title}</a></h4>
              <p>SKU: ${product.sku || '-'}</p>
              <p>Merk: ${product.vendor || '-'}</p>
            </div>
            <button class="search-add-btn" data-product-data="${productDataString}">Toevoegen</button>
          </div>`;
        }).join('');
        
        resultsContainer.querySelectorAll('.search-add-btn').forEach(btn => {
          btn.addEventListener('click', function() {
            const productDataString = this.dataset.productData;
            if (productDataString) {
              const product = JSON.parse(productDataString);
              addFoundProductToList(product, this);
            }
          });
        });
      }

      async function addFoundProductToList(product, button) {
        button.disabled = true;
        button.textContent = 'Bezig...';
        try {
          const response = await fetch(`/products/${product.handle}.js`);
          if (!response.ok) throw new Error('Productdetails ophalen mislukt.');
          const fullProduct = await response.json();
          await addProductToQuickOrder(fullProduct, button);
        } catch (error) {
           console.error('Error adding product from search:', error);
           alert('Er is een onbekende fout opgetreden bij het toevoegen van het product.');
           button.disabled = false;
           button.textContent = 'Toevoegen';
        }
      }

      
      async function addProductToQuickOrder(productData, button) {
        const originalText = 'Toevoegen';
        try {
          const productGid = `gid://shopify/Product/${productData.id}`;

          // Check if GID is already in our session list
          if (fullProductGidList.includes(productGid)) {
            button.textContent = 'Al in lijst';
            setTimeout(() => {
              button.disabled = false;
              button.textContent = originalText;
            }, 2000);
            return;
          }

          const success = await addQuickOrderList([productGid]);
          
          if (success) {
              fullProductGidList.unshift(productGid); // Add to our GID list
              
              // Adicionar aos detalhes para que os filtros funcionem (Vendor e Tags)
              if (!allProductDetails.some(p => p.id === productGid)) {
                  allProductDetails.push({ 
                      id: productGid, 
                      vendor: productData.vendor, 
                      tags: productData.tags 
                  });
              }
              // Atualizar dropdowns caso o Vendor/Tags seja novo e count caso o count não tenha filtro
              populateFilterDropdowns();
              if (typeof isFilterActive === 'undefined' || !isFilterActive || !document.getElementById('quick-order-filters')) {
                  const listHeader = document.querySelector('.list-header p');
                  if (listHeader) listHeader.textContent = `Je hebt ${fullProductGidList.length} producten in je lijst`;
                  renderPage(); // Renderizar a nova página
              } else {
                  applyQuickFilters(); // Re-avalia o novo artigo no filtro caso seja necessário mostrá-lo
              }

              button.textContent = 'Toegevoegd!';

              // If this is the first product, the page structure for the list is missing.
              // We must create it before rendering the product rows.
              if (fullProductGidList.length === 1) {
                const listWrapper = document.getElementById('quick-order-list-wrapper');
                const emptyMessage = document.getElementById('empty-list-message');
                if (listWrapper) listWrapper.style.display = 'block';
                if (emptyMessage) emptyMessage.style.display = 'none';
              }
              
              // For all cases (first or subsequent product), re-render the page content.
              currentPage = 1;
              renderPage();
              const listHeader = document.querySelector('.list-header p');
              if (listHeader) {
                listHeader.textContent = `Je hebt ${fullProductGidList.length} producten in je lijst`;
              }
              
              setTimeout(() => {
                button.disabled = false;
                button.textContent = originalText;
              }, 2000);

          } else {
              button.disabled = false;
              button.textContent = originalText;
          }
        } catch (error) {
          console.error('Error adding product:', error);
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    }
  });


/**
 * Extracts a user-friendly error message from a fetch response JSON body.
 * It checks for various common error formats from Shopify proxies and GraphQL.
 * @param {object | string} result - The JSON body from the response.
 * @returns {string} The extracted error message or a fallback message.
 */
function getErrorMessageFromResult(result) {
    if (typeof result === 'string') {
        return result;
    }
    // Handles { success: false, errors: [ { message: "..." } ] }
    if (Array.isArray(result.errors) && result.errors.length > 0) {
        return result.errors[0].message;
    }
    // Handles { success: false, error: "..." }
    if (result.error) {
        return result.error;
    }
    // Fallback for other GraphQL error structures
    if (result?.data?.customerUpdate?.userErrors?.length > 0) {
        return result.data.customerUpdate.userErrors[0].message;
    }
    return 'Unknown error.';
}

async function fetchFullProductList() {
  console.time('fetchFullProductList');
  const loader = document.getElementById('loader-wrapper');
  const content = document.getElementById('quick-order-content');

  try {
    const response = await fetch('/apps/quick-manager', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ intent: 'retrieve' })
    });
    let result = await response.json();

    if (useMockRetrieveResponse && Array.isArray(result?.productGids)) {
      const availableGids = result.productGids;
      const draftCount = Math.min(availableGids.length, 2);
      const deletedCount = availableGids.length > 0 ? 1 : 0;
      const draftGids = availableGids.slice(0, draftCount);

      result = {
        success: true,
        products: availableGids,
        sync_metadata: {
          deleted_count: deletedCount,
          draft_count: draftCount,
          draft_gids: draftGids,
          ...(deletedCount > 0 && {
            message_deleted: `${deletedCount} producten zijn verwijderd uit de catalogus omdat ze niet meer bestaan.`
          }),
          ...(draftCount > 0 && {
            message_draft: `${draftCount} producten zijn momenteel niet beschikbaar of worden bijgewerkt, waardoor ze niet in de lijst worden weergegeven. U kunt deze producten verwijderen of wachten tot ze weer beschikbaar zijn.`
          })
        }
      };
    }
    const normalized = normalizeRetrieveResponse(result);
    console.log('[Bestel Snel] Retrieve response:', result);
    console.log('[Bestel Snel] Retrieve normalized:', normalized);
    console.log('[Bestel Snel] Retrieve mode:', normalized.isLegacy ? 'legacy' : 'new');
    
    if (result.success && normalized.gids) {
      fullProductGidList = normalized.gids;
      
      console.log('Quick order GID list loaded:', fullProductGidList.length, 'items');

      // We don't need the full list in localStorage anymore.
      localStorage.removeItem('quickOrderList');

      if (normalized.isLegacy) {
        await validateAndCleanProductList();
      }

      // Hide the deleted message as requested by user
      // if (normalized.syncMetadata?.deleted_count > 0 && normalized.syncMetadata?.message_deleted) {
      //   displayDismissibleAlert({
      //     id: 'quick-order-deleted-alert',
      //     message: normalized.syncMetadata.message_deleted
      //   });
      // }

      if (normalized.syncMetadata?.draft_count > 0 && normalized.syncMetadata?.message_draft) {
        displayDismissibleAlert({
          id: 'quick-order-draft-alert',
          message: normalized.syncMetadata.message_draft,
          actionLabel: 'Conceptproducten verwijderen',
          onAction: async () => {
            const draftGids = normalized.syncMetadata?.draft_gids || [];
            const success = await deleteDraftProducts(draftGids);
            if (success) {
              clearDismissibleAlert('quick-order-draft-alert');
              fetchFullProductList();
            }
          }
        });
      }

      // Now, proceed with rendering the clean list.
      if (fullProductGidList.length > 0) {
        renderPage();
      }
      
      // Update header count with the CORRECT number
      const listHeader = document.querySelector('.list-header p');
      if (listHeader) {
          listHeader.textContent = `Je hebt ${fullProductGidList.length} producten in je lijst`;
      }
      
      // If the list is now empty after cleaning, ensure the empty message is shown.
      // This handles the case where the list started with items but all were invalid.
      if (fullProductGidList.length === 0) {
          const listWrapper = document.getElementById('quick-order-list-wrapper');
          const emptyMessage = document.getElementById('empty-list-message');
          if (listWrapper) listWrapper.style.display = 'none';
          if (emptyMessage) emptyMessage.style.display = 'block';
      } else {
          const listWrapper = document.getElementById('quick-order-list-wrapper');
          const emptyMessage = document.getElementById('empty-list-message');
          if (listWrapper) listWrapper.style.display = 'block';
          if (emptyMessage) emptyMessage.style.display = 'none';
      }

      // Hide loader and show content
      if(loader) loader.style.display = 'none';
      if(content) content.style.display = 'block';

    } else {
      // Handle cases where the fetch was successful but the app returned an error
      if(loader) loader.innerHTML = '<p>Kon producten niet laden. Probeer het later opnieuw.</p>';
    }
  } catch (e) {
    console.error('Error fetching full product list:', e);
    if(loader) loader.innerHTML = '<p>Pagina in onderhoud, kom later terug.</p>';
  } finally {
    console.timeEnd('fetchFullProductList');
  }
}

function normalizeRetrieveResponse(result) {
  // Check for NEW format first (with sync_metadata)
  if (Array.isArray(result?.products)) {
    const gids = result.products
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object') return item.gid || item.id || null;
        return null;
      })
      .filter(Boolean);

    return {
      gids,
      syncMetadata: result.sync_metadata || null,
      isLegacy: false
    };
  }

  // Fall back to LEGACY format
  if (Array.isArray(result?.productGids)) {
    return {
      gids: result.productGids,
      syncMetadata: null,
      isLegacy: true
    };
  }

  return {
    gids: null,
    syncMetadata: null,
    isLegacy: false
  };
}

async function addQuickOrderList(productGidsArray) {
  try {
    const response = await fetch('/apps/quick-manager', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        intent: 'add',
        productGids: productGidsArray
      })
    });
    const result = await response.json();
    
    // An error can be indicated by !response.ok OR by a success=false flag in the body
    if (!response.ok || !result.success) {
      const errorMessage = getErrorMessageFromResult(result);
      alert('Kon product niet toevoegen: ' + errorMessage);
      return false;
    }
    return true;
  } catch (e) {
    console.error('Error:', e);
    alert('Kon product niet toevoegen door een verbindingsfout. Controleer je internet en probeer het opnieuw.');
    return false;
  }
}

async function removeProductsFromQuickOrder(productGidsArray) {
  if (!productGidsArray || productGidsArray.length === 0) return true;

  console.log('GIDs to be removed:', productGidsArray);

  try {
    const response = await fetch('/apps/quick-manager', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        intent: 'remove',
        productGids: productGidsArray
      })
    });
    const result = await response.json();

    if (!response.ok || !result.success) {
      const errorMessage = getErrorMessageFromResult(result);
      console.error('Error removing products from list:', errorMessage);
      return false;
    }
    return true;
  } catch (e) {
    console.error('Connection error while removing products:', e);
    return false;
  }
}

async function deleteDraftProducts(productGidsArray) {
  if (!productGidsArray || productGidsArray.length === 0) return true;

  try {
    const response = await fetch('/apps/quick-manager', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        intent: 'delete_draft_products',
        productGids: productGidsArray
      })
    });

    const result = await response.json();
    if (!response.ok || !result.success) {
      const errorMessage = getErrorMessageFromResult(result);
      alert('Kon conceptproducten niet verwijderen: ' + errorMessage);
      return false;
    }

    return true;
  } catch (e) {
    console.error('Connection error while removing draft products:', e);
    alert('Kon conceptproducten niet verwijderen door een verbindingsfout. Probeer het opnieuw.');
    return false;
  }
}

function ensureNotificationArea() {
  let notificationArea = document.getElementById('quick-order-notification-area');
  if (!notificationArea) {
    notificationArea = document.createElement('div');
    notificationArea.id = 'quick-order-notification-area';

    const container = document.querySelector('.section-template--page');
    if (container) {
      container.insertBefore(notificationArea, container.firstChild);
    } else {
      document.body.insertBefore(notificationArea, document.body.firstChild);
    }
  }

  return notificationArea;
}

function clearDismissibleAlert(alertId) {
  const notificationArea = document.getElementById('quick-order-notification-area');
  const existing = notificationArea?.querySelector(`[data-alert-id="${alertId}"]`);
  if (existing) {
    existing.remove();
  }
}

function displayDismissibleAlert({ id, message, actionLabel, onAction }) {
  const notificationArea = ensureNotificationArea();
  const existing = notificationArea.querySelector(`[data-alert-id="${id}"]`);

  const alertNode = existing || document.createElement('div');
  alertNode.className = 'quick-order-notification';
  alertNode.dataset.alertId = id;

  alertNode.innerHTML = '';

  const messageNode = document.createElement('p');
  messageNode.textContent = message;

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.innerHTML = '&times;';
  closeButton.onclick = () => alertNode.remove();

  alertNode.appendChild(messageNode);

  if (actionLabel && typeof onAction === 'function') {
    const actionButton = document.createElement('button');
    actionButton.type = 'button';
    actionButton.className = 'quick-order-notification__action';
    actionButton.textContent = actionLabel;
    actionButton.addEventListener('click', async () => {
      actionButton.disabled = true;
      await onAction();
      actionButton.disabled = false;
    });
    alertNode.appendChild(actionButton);
  }

  alertNode.appendChild(closeButton);

  if (!existing) {
    notificationArea.appendChild(alertNode);
  }
}

async function validateAndCleanProductList() {
  console.log('[Bestel Snel] Starting validation of product list...');
  const originalCount = fullProductGidList.length;
  if (originalCount === 0) return;

  const CHUNK_SIZE = 250; // Max IDs per 'nodes' query
  const chunks = [];
  for (let i = 0; i < originalCount; i += CHUNK_SIZE) {
    chunks.push(fullProductGidList.slice(i, i + CHUNK_SIZE));
  }

  const allValidNodes = [];
  try {
    for (const chunk of chunks) {
      const storefrontQuery = `
        query getProductsByIds($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
            }
          }
        }
      `;
      const storefrontData = await fetchFromStorefrontAPI(storefrontQuery, { ids: chunk });
      allValidNodes.push(...storefrontData.nodes.filter(Boolean));
    }
  } catch (error) {
    console.error('[Bestel Snel] Error during product list validation:', error);
    // Don't proceed with cleanup if validation fails, as we might remove products by mistake.
    return;
  }

  const validGids = new Set(allValidNodes.map(node => node.id));
  const invalidGids = fullProductGidList.filter(gid => !validGids.has(gid));

  if (invalidGids.length > 0) {
    console.warn(`[Bestel Snel] Found ${invalidGids.length} invalid products. They will be removed.`, invalidGids);

    // Update global state immediately
    fullProductGidList = fullProductGidList.filter(gid => validGids.has(gid));
    
  } else {
    console.log('[Bestel Snel] Product list validation complete. All products are valid.');
  }
}
})();